<section class="login-page-section-top blog-title-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">
                    <h3 class="txt-advert animated fadeInUp">{{blogTitle}}</h3>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<main class="container blog-details">
    <section class="content my-cont">
        <div *ngIf="blogImage">
            <div class="blog_card">
                <img src="{{blogImage}}" alt="">
            </div>
        </div>
        <div class="blog-page-content">
            <div [innerHTML]="blogContent"></div>
        </div>
    </section>
    <div class="col-md-3 left-news news">
        <div class="news-headig">
            <h4>TPL News</h4>
        </div>
        <div class="center-blog big-news">
            <div class="swiper blogcenter">
                <swiper class="swiper-wrapper" fxFlex="auto" [config]="Newscenter_config" [disabled]="disabled"
                    (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let news of tplNews " class="swiper-slide">
                        <div class="banner-image">
                            <img src="{{news.newsImage}}" alt="">
                            <div class="heading w-100">
                                <h5>{{news.title}}
                                </h5>
                                <div class="date"> <span><i class="bi bi-calendar"></i></span>
                                    {{news.created_at | date:
                                    'MMM d, y'}}</div>
                            </div>
                        </div>
                    </div>
                </swiper>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</main>